import * as React from 'react';
import { CPlannerTask } from '../../Entity/PlannerTaskObj';
import { MIAPACons } from '../../Utils/MipaConstant';
import  './planner.scss';
import { Callout } from 'office-ui-fabric-react/lib/Callout';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { DirectionalHint } from 'office-ui-fabric-react/lib/ContextualMenu';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { GraphRequest } from '../../Utils/GraphRequest';
import CheckItemAction from './TaskCheckListActions';

export interface IProps {
    data?: CPlannerTask;
    title;
    Header;
    Phrases;
    rem;
    ReloadPlannerTasks;
    Progress;
}
export interface IContextualMenuState {
    directionalHint?: DirectionalHint;
    directionalHintForRTL?: DirectionalHint;
    useDirectionalHintForRtl?: boolean;
    isBeakVisible?: boolean;
    gapSpace?: number;
    beakWidth?: number;
    edgeFixed?: boolean;
    DetailCalloutVisible?: boolean;
    TaskDetails;
}




export default class TaskChecklistEdit extends React.Component<IProps, IContextualMenuState>{

    private _menuButtonElement: HTMLElement | null;
    constructor(props: IProps) {
        super(props);
        this.state = {
            DetailCalloutVisible: false,
            directionalHint: DirectionalHint.topCenter,
            beakWidth: 16,
            TaskDetails: null
        };
    }
    //UserEmail.split("@")[1]
    public render() {
        
        const { DetailCalloutVisible, beakWidth, TaskDetails } = this.state;
        let rowcss = "ms-Grid-row miparow " + 'detailrow';
        let checkitems = [];


        if (TaskDetails == null) {
            checkitems.push(<Spinner key="1" size={SpinnerSize.large} />);
        }
        else {
            Object.keys(TaskDetails.checklist).map((key) => {
                checkitems.push(
                    <div className={rowcss} key={key}>
                        <div className="ms-Grid-col ms-sm9 taskchecklist">
                            <Checkbox
                                label={TaskDetails.checklist[key].title}
                                defaultChecked={TaskDetails.checklist[key].isChecked}
                                onChange={(ev: React.FormEvent<HTMLElement>, isChecked: boolean) => {
                                    this._onCheckboxChange(ev, isChecked, key, TaskDetails.checklist[key].title);
                                }}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm3 ms-u-textAlignRight">
                            <CheckItemAction referenceid={key} 
                                             Update={this.CheckItemActionUpdate} 
                                             Phrases={this.props.Phrases} 
                                             Title={TaskDetails.checklist[key].title}
                                             />
                        </div>
                    </div>
                );
            });
        }
        return (
            <span style={{ cursor: 'pointer' }} ref={menuButton => (this._menuButtonElement = menuButton)} onClick={this._onMenuClicked} title={this.props.title}>
                <i className="ms-Icon ms-Icon--CheckboxComposite"></i><label style={{ fontSize: '14px', marginLeft: '2px', display: 'inline-block', marginTop: '-8px' }}>{this.props.rem}</label>

                {DetailCalloutVisible ? (
                    <Callout

                        className="ms-Callout-callout"
                        onDismiss={this._onCalloutDismiss}
                        target={this._menuButtonElement}
                        directionalHint={DirectionalHint.topAutoEdge}
                        coverTarget={false}
                        isBeakVisible={true}
                        gapSpace={0}
                        beakWidth={beakWidth}
                    >
                        <div className='detailcallout'>
                            <div className='plannerdetailheader'>
                                {this.props.title}
                            </div>
                            <div className="ms-Callout-inner" style={{ padding: '10px' }}>
                                <div className="ms-Callout-content ms-Grid">
                                    {checkitems}
                                </div>
                            </div>
                        </div>
                    </Callout>
                ) : null}
            </span>
        );
    }
    private _onCheckboxChange = (ev: React.FormEvent<HTMLElement>, isChecked: boolean, prop, title) => {
        let detailapi = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.TaskDetail.replace('{0}', this.props.data.id).replace('?v=', '');
        let header = { ...this.props.Header };
        var etag = this.state.TaskDetails["@odata.etag"];
        header["If-Match"] = etag;
        header["Prefer"] = "return=representation";

        let item = {
            'checklist': {
            }
        };
        if(isChecked==null){
            item.checklist[prop]=null;
        }
        else{
            item.checklist[prop] = {
                "@odata.type": "#microsoft.graph.plannerChecklistItem",
                isChecked: isChecked,
                title: title
            };
        }
        GraphRequest.Patch(detailapi, header, item, (detail) => {
            this.setState({
                TaskDetails: detail.data
            });
            this.props.ReloadPlannerTasks(this.props.data.col);
        }, (error) => {

        }, this.props.Progress);

    }
    private CheckItemActionUpdate = (key, type,title) => {
        if(type=='promot')
        {
            var newTaskobj = {
                assignments: {},
                bucketId: this.props.data.bucketId,
                planId: this.props.data.planId,
                title: title,
                dueDateTime : this.props.data.dueDateTime
            };
            for (var assignedTo in this.props.data.assignments) {
                newTaskobj.assignments[assignedTo] = { '@odata.type': "microsoft.graph.plannerAssignment", orderHint: " !" };
            }
            let Taskapi = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.PlannerTaks;
            let header = { ...this.props.Header };
            GraphRequest.POST(Taskapi,header,newTaskobj,(res)=>{
                this.props.ReloadPlannerTasks(this.props.data.col);
            },(error)=>{},this.props.Progress);    
        }
        this._onCheckboxChange(null,null,key,null);
    }

    private _onCalloutDismiss = (): void => {
        this.setState({
            DetailCalloutVisible: false
        });
    }

    private _onMenuClicked = (): void => {
        if (this.state.TaskDetails == null) {
            let detailapi = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.TaskDetail.replace('{0}', this.props.data.id) + Math.round(+new Date() / 1000);
            GraphRequest.GET(detailapi, this.props.Header, (detail) => {

                this.setState({
                    TaskDetails: detail.data
                });
            }, (error) => {

            }, this.props.Progress);
        }
        this.setState({
            DetailCalloutVisible: !this.state.DetailCalloutVisible
        });
    }

}
